module.exports = __webpack_public_path__ + "static/media/03.f299be40.jpg";